import { render, staticRenderFns } from "./pay_help_ios.vue?vue&type=template&id=9b8ee836&scoped=true"
import script from "./pay_help_ios.vue?vue&type=script&lang=js"
export * from "./pay_help_ios.vue?vue&type=script&lang=js"
import style0 from "./pay_help_ios.vue?vue&type=style&index=0&id=9b8ee836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8ee836",
  null
  
)

export default component.exports